import React from "react";

import imgThumbnail1 from "styles/common/img/common/leftbtn.png";
import imgThumbnail8 from "styles/common/img/common/imgIcon3.png";

function ToggleButton({ toggleLnb, isLnbActive, isLnbHasNewAlert, isLnbOpen }) {
    const handleClickToggleButton = () => {
        toggleLnb();
    };

    return (
        <>
            {isLnbActive && (
                <div className="leftBtn" onClick={handleClickToggleButton}>
                    {isLnbHasNewAlert && (
                        <div className="leftN">
                            <img src={imgThumbnail8} alt="서랍" />
                        </div>
                    )}
                    <img src={imgThumbnail1} alt="서랍" />
                </div>
            )}
        </>
    );
}

export default ToggleButton;
